import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { appConfig } from 'src/config';
import { Campaign } from './campaigns';
import { withSessionExpiredHandler } from 'src/api/common/baseQueryWithAuth';

const baseQuery = withSessionExpiredHandler(fetchBaseQuery({
  baseUrl: `${appConfig.URL_REST_V2}`,
  credentials: 'include',
  prepareHeaders: (headers, { type }) => {
    const token = typeof window !== 'undefined' ? window.localStorage.getItem('token') : null;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    if (type === 'mutation' && !headers.has('Content-Type')) {
      headers.set('Content-Type', 'application/json; charset=UTF-8');
    }
    return headers;
  },
}));

export const campaignsV2Api = createApi({
  tagTypes: ['Campaign'],
  baseQuery,
  reducerPath: 'campaignsV2Api',
  endpoints: (builder) => ({
    pauseCampaign: builder.mutation<void, Campaign['id']>({
      async queryFn(id, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ({
          url: `campaigns/${id}/pause`,
          method: 'PUT',
          responseHandler: 'text',
        });

        if (result.error) {
          return { error: result.error };
        }

        return { data: undefined };
      },
      invalidatesTags: [
        { type: 'Campaign', id: 'campaigns' },
        { type: 'Campaign', id: 'campaign' },
      ],
    }),
    resumeCampaign: builder.mutation<void, Campaign['id']>({
      async queryFn(id, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ({
          url: `campaigns/${id}/resume`,
          method: 'PUT',
          responseHandler: 'text',
        });

        if (result.error) {
          return { error: result.error };
        }

        return { data: undefined };
      },
      invalidatesTags: [
        { type: 'Campaign', id: 'campaigns' },
        { type: 'Campaign', id: 'campaign' },
      ],
    }),
  }),
});

export const { usePauseCampaignMutation, useResumeCampaignMutation } = campaignsV2Api;
